<template>
    <div class="dictionary-page">
        <div class="page-title">
            <div class="ctrl-btns">
                    <a-input-search 
                      placeholder="请输入查询内容" 
                      @search="onSearch"
                      v-model="cubeName"
                      class="fr"
                    />
            </div>
            <span class="name">上线管理</span>
        </div>
        <div class="table-wrap">
            <a-table 
                :columns="columns" 
                :data-source="list" 
                :pagination="false" 
                :bordered="false"
                >
                <!-- :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
                <template slot="sort" slot-scope="text,record,index">
                  {{++index}}
                </template>
                <template slot="actions" slot-scope="text,record">
                    <a-button type="link" @click="online(record.cubeId)">上线</a-button>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
import { messageTips } from '../../until/tools';
const columns = [
    {
        title: '序号',
        dataIndex: 'sort',
        key: 'sort',
        scopedSlots: { customRender: 'sort' },
    },
    {
        title: '库名称',
        dataIndex: 'cubeName',
        key: 'cubeName',
    },
    {
        title: '上次上线时间',
        dataIndex: 'onlineTime',
        key: 'onlineTime',
    },
    {
        title: '操作',
        dataIndex: 'actions',
        align:'center',
        key: 'actions',
        scopedSlots: { customRender: 'actions' },
    },
];
export default {
    data() {
        return {
            columns,
            list:[],
            dimensionId:null,
            selectedRowKeys:[],
            cubeName:'',
        }
    },
    created() {
        this.getOnlineCube();
    },
    methods:{
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        onSearch(){
            this.getOnlineCube(this.cubeName)
        },
        getOnlineCube(cubeName) {
            this.$http.getOnlineCube({cubeName}).then(res=>{
                if(res&&res.onlineCubeList) {
                    this.list = res.onlineCubeList;
                }
            })
        },
        online(cubeId) {
            this.$http.onlineJob({cubeId}).then(res=>{
                if(res) {
                    messageTips(res.message,3)
                    this.getOnlineCube(this.cubeName)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../scss/inputs/dictionary.scss';
</style>
